import { Info, ExternalLink, Mail } from "lucide-react";
import { Button } from "@/components/ui/button";
import { useNavigate } from "react-router-dom";

export function AboutSection() {
  const navigate = useNavigate();
  const appVersion = "1.0.0";

  return (
    <div className="space-y-4">
      <div className="flex items-center gap-2 text-sm font-medium text-muted-foreground">
        <Info className="w-4 h-4" />
        About
      </div>
      
      <div className="pl-6 space-y-3">
        <div className="flex items-center justify-between">
          <span className="text-sm text-muted-foreground">Version</span>
          <span className="text-sm font-medium">{appVersion}</span>
        </div>
        
        <div className="flex flex-col gap-2">
          <Button
            variant="link"
            className="h-auto p-0 justify-start text-sm text-muted-foreground hover:text-foreground"
            onClick={() => navigate('/privacy')}
          >
            <ExternalLink className="w-3 h-3 mr-2" />
            Privacy Policy
          </Button>
          
          <Button
            variant="link"
            className="h-auto p-0 justify-start text-sm text-muted-foreground hover:text-foreground"
            onClick={() => navigate('/terms')}
          >
            <ExternalLink className="w-3 h-3 mr-2" />
            Terms of Service
          </Button>
          
          <Button
            variant="link"
            className="h-auto p-0 justify-start text-sm text-muted-foreground hover:text-foreground"
            onClick={() => navigate('/cookie-policy')}
          >
            <ExternalLink className="w-3 h-3 mr-2" />
            Cookie Policy
          </Button>
          
          <Button
            variant="link"
            className="h-auto p-0 justify-start text-sm text-muted-foreground hover:text-foreground"
            onClick={() => window.location.href = 'mailto:settleupgolf@gmail.com?subject=SettleUp%20Support'}
          >
            <Mail className="w-3 h-3 mr-2" />
            Contact Support
          </Button>
        </div>
        
        <p className="text-xs text-muted-foreground pt-2">
          Made with ⛳ for golfers everywhere
        </p>
      </div>
    </div>
  );
}
